function InPageNavigation() {
  const inPageNavigation = document.querySelector(
    ".c-in-page-navigation--sticky",
  );

  if (!inPageNavigation) return;

  /* ------------------------------------
   * Sticky state
   * ---------------------------------- */
  const stickyObserver = new IntersectionObserver(
    ([entry]) => {
      inPageNavigation.toggleAttribute("data-stuck", !entry.isIntersecting);
    },
    { threshold: 1 },
  );

  stickyObserver.observe(inPageNavigation);

  /* ------------------------------------
   * Navigation height + anchor offset
   * ---------------------------------- */
  let inPageNavigationHeight = inPageNavigation.offsetHeight;

  const updateInPageNavigationHeight = () => {
    inPageNavigationHeight = inPageNavigation.offsetHeight;

    inPageNavigation
      .querySelectorAll("a.c-in-page-navigation__link")
      .forEach((link) => {
        const id = link.getAttribute("href")?.slice(1);
        const target = id && document.getElementById(id);
        if (target) {
          target.style.scrollMarginTop = `${inPageNavigationHeight}px`;
        }
      });
  };

  window.addEventListener("resize", updateInPageNavigationHeight);
  updateInPageNavigationHeight();

  /* ------------------------------------
   * ScrollSpy using scroll position
   * ---------------------------------- */
  const navLinks = Array.from(
    inPageNavigation.querySelectorAll("a.c-in-page-navigation__link"),
  );

  const sectionMap = navLinks
    .map((link) => {
      const id = link.getAttribute("href")?.slice(1);
      const section = id && document.getElementById(id);
      return section ? { link, section } : null;
    })
    .filter(Boolean)
    .sort((a, b) => a.section.offsetTop - b.section.offsetTop);

  let activeLink = null;

  const setActiveLink = (link) => {
    if (activeLink === link) return;
    activeLink = link;

    navLinks.forEach((l) => {
      l.classList.remove("c-in-page-navigation__link--active");
      l.removeAttribute("aria-current");
    });

    if (link) {
      link.classList.add("c-in-page-navigation__link--active");
      link.setAttribute("aria-current", "true");
      link.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const onScroll = () => {
    const offset = inPageNavigationHeight + 1;

    let current = -1;

    for (let i = sectionMap.length - 1; i >= 0; i--) {
      const rect = sectionMap[i].section.getBoundingClientRect();
      if (rect.top <= offset && rect.bottom > offset) {
        current = i;
        break;
      }
    }

    setActiveLink(current !== -1 ? sectionMap[current].link : null);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll(); // set initial active link

  /* ------------------------------------
   * Keyboard navigation only scrolls nav
   * ---------------------------------- */
  navLinks.forEach((link, index) => {
    link.addEventListener("keydown", (e) => {
      let targetIndex;

      switch (e.key) {
        case "ArrowRight":
          targetIndex = (index + 1) % navLinks.length;
          break;
        case "ArrowLeft":
          targetIndex = (index - 1 + navLinks.length) % navLinks.length;
          break;
        case "Home":
          targetIndex = 0;
          break;
        case "End":
          targetIndex = navLinks.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      navLinks[targetIndex].focus();

      // Scroll nav horizontally to keep focused item visible
      navLinks[targetIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    });
  });
}

export default InPageNavigation;
